import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classnames from 'classnames';
import langIsEn from '../../utils/langIsEn';
import styles from './ContentRelatedProject.css';

class ContentRelatedProject extends Component {
  static propTypes = {
    project: PropTypes.object,
  };

  render() {
    const { project } = this.props;

    return (
      <div className="col--4of12">
        <Link to={`/projects/${project.engName}`} className={styles.link}>
          <div className={styles.listImg}>
            <img
              className={classnames(styles.content, 'animated fadeInUp')}
              src={project.linkPicURL}
              alt={project.engName}
            />
          </div>
          <p className={styles.tags}>{project.tags.join(', ')}</p>
          <p className={styles.name}>
            <span className={styles.engName}>{project.engName}</span>
            {!langIsEn() && project.chtName && <span className={styles.chtName}>{project.chtName}</span>}
          </p>
        </Link>
      </div>
    )
  }
}

export default ContentRelatedProject;



// WEBPACK FOOTER //
// ./src/components/content-related-project/ContentRelatedProject.js